import { gateway } from "../../../gateway";
import { IPaypalMerchantInfo } from "../interfaces";

export const getMerchantInfo = async (): Promise<IPaypalMerchantInfo> => {
  try {
    const response: IPaypalMerchantInfo = (await gateway.get<IPaypalMerchantInfo>("/paypal/e-commerce/self")).data;
    return response;
  } catch (error: any) {
    console.error("Error fetching merchant info:", error);
    const errorMessage = error?.response?.data?.message || error?.message || "Failed to fetch merchant info";
    throw new Error(errorMessage);
  }
};
